import { render, staticRenderFns } from "./CreateLoad.vue?vue&type=template&id=56bd8dbe&scoped=true"
import script from "./CreateLoad.vue?vue&type=script&lang=js"
export * from "./CreateLoad.vue?vue&type=script&lang=js"
import style0 from "./CreateLoad.vue?vue&type=style&index=0&id=56bd8dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd8dbe",
  null
  
)

export default component.exports